export default `
阿lou話佢條team日日爆數，佢team人一定好鍾意佢。

不過都照叫佢哋評分啦，睇下邊個表演唔好就再同上頭交代。
`;
